// extracted by mini-css-extract-plugin
export default {"OctopusSyncHeader":"APPOctoSync_OctopusSyncHeader__JkG+f","OctopusSyncBackButton":"APPOctoSync_OctopusSyncBackButton__GfwlU"};